import React from 'react'
import PropTypes from 'prop-types'
import { HeaderGradient } from 'components'
import {
  RESPONSIVE_BREAKPOINT_VERSIONS,
  ResponsiveBreakpointsProvider,
  useResponsiveBreakpointsVersion
} from 'contexts/ResponsiveBreakpointsContext'
import GlobalActionMenu from '../GlobalActionMenu/GlobalActionMenu'
import {
  Container,
  Header,
  Title,
  IconContainer,
  ActionButton,
  Content,
  TitleContainer
} from './CollectionContent.styles'
import HamburguerMenu from '../HamburguerMenu/HamburguerMenu'

const CollectionContent = ({
  icon,
  title = 'Unknown',
  table,
  actionTitle,
  actionCallback,
  actionDisabled = false,
  hasGradient = false,
  subHeader,
  contentId,
  disableContentScroll = false,
  isPlaylistLibrary = false,
  isWelcome = false
}) => {
  const responsiveBreakpointsVersion = useResponsiveBreakpointsVersion()
  const responsiveBreakpointsV2 =
    responsiveBreakpointsVersion === RESPONSIVE_BREAKPOINT_VERSIONS.V2

  return (
    <Container $isPlaylistLibrary={isPlaylistLibrary} $isWelcome={isWelcome}>
      <Header $isPlaylistLibrary={isPlaylistLibrary} $isWelcome={isWelcome}>
        <TitleContainer>
          {/* These controls coordinate with ResponsiveLayout, which remains
              legacy until the app-shell phase. */}
          <ResponsiveBreakpointsProvider
            value={RESPONSIVE_BREAKPOINT_VERSIONS.LEGACY}>
            <HamburguerMenu />
          </ResponsiveBreakpointsProvider>
          <div className="relative w-full flex">
            <Title
              $isPlaylistLibrary={isPlaylistLibrary}
              $isWelcome={isWelcome}
              $responsiveBreakpointsV2={responsiveBreakpointsV2}>
              {title}
            </Title>
            {icon && <IconContainer>{icon}</IconContainer>}

            {hasGradient && !isWelcome && !isPlaylistLibrary && (
              <HeaderGradient style={{ margin: 0 }} />
            )}
          </div>
        </TitleContainer>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {actionTitle && (
            <ActionButton
              $responsiveBreakpointsV2={responsiveBreakpointsV2}
              disabled={actionDisabled}
              onClick={actionCallback}>
              {actionTitle}
            </ActionButton>
          )}
          {/* Keep global actions aligned with the same legacy shell. */}
          <ResponsiveBreakpointsProvider
            value={RESPONSIVE_BREAKPOINT_VERSIONS.LEGACY}>
            <GlobalActionMenu
              hideMobileExtras={isWelcome || isPlaylistLibrary}
              showMobileSearchIcon={!(isWelcome || isPlaylistLibrary)} />
          </ResponsiveBreakpointsProvider>
        </div>
      </Header>
      {subHeader}
      <Content
        id={contentId}
        $disableScroll={disableContentScroll}
        $isPlaylistLibrary={isPlaylistLibrary}
        $isWelcome={isWelcome}>
        {table}
      </Content>
    </Container>
  )
}

CollectionContent.propTypes = {
  icon: PropTypes.element,
  subHeader: PropTypes.element,
  contentId: PropTypes.string,
  title: PropTypes.string,
  table: PropTypes.element,
  actionTitle: PropTypes.string,
  actionCallback: PropTypes.func,
  actionDisabled: PropTypes.bool,
  hasGradient: PropTypes.bool,
  disableContentScroll: PropTypes.bool,
  isPlaylistLibrary: PropTypes.bool,
  isWelcome: PropTypes.bool
}

export default CollectionContent
